// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"AdminNavbar_breadCrumbs__1ghRF"};